import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/cms/v1/audience`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const audienceApi = {
  getAudiences: (params) => instance().get('', { params }),
  postAudience: (data) => instance().post('', data),
  patchAudience: (data) => instance().patch('', data),
  deleteAudience: (params, data) => instance().delete('', { params, data }),
  getAudienceUploadHistories: (params) => instance().get('/audience-upload-history', { params }),
  getLineAudienceData: (params) => instance().get('/line-audience-data', { params }),
  postLineAudience: (data) => instance().post('/upload-line-audience', data),
  postFacebookAudience: (data) => instance().post('/upload-facebook-audience', data)
}

export default audienceApi



// WEBPACK FOOTER //
// ./src/api/audience.js